/**
 * Created by Ning Jiang on 3/20/2017.
 */

import { ServerDataParser } from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import { IBarbarianFuryGameData, IBarbarianFuryServerData } from "./data/IBarbarianFuryServerData";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { SpinServerDataParser } from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";

export class BarbarianFuryServerDataParser extends SpinServerDataParser {

    private static _LOW_SYMBOLS: string[] = ["L1", "L2", "L3", "L4"];

    constructor() {
        super();
    }

    private static getRandomLowSymbol(): string {
        return BarbarianFuryServerDataParser._LOW_SYMBOLS[MathHelper.randomNumberInRange(0, 3)];
    }

    public parseStackedSpinTriggered(rawData: IBarbarianFuryServerData): boolean {
        return rawData.stackedSpinTriggered;
    }

    public parseActiveStackedSymbol(rawData: IBarbarianFuryServerData): string {
        return rawData.activeStackedSymbol;
    }

    public parseInitialStackOverlay(rawData: IBarbarianFuryServerData): boolean[] {
        return rawData.initialStackOverlay;
    }

    public parseStackOverlay(rawData: IBarbarianFuryGameData): boolean[][] {
        return rawData.stackOverlay;
    }

    public parseDoReelNudge(rawData: IBarbarianFuryGameData): boolean[] {
        return rawData.doReelNudge.concat();
    }

    public parseDoScatterNudge(rawData: IBarbarianFuryGameData): boolean[] {
        return rawData.doScatterNudge.concat();
    }

    // override
    /*public parseReels(rawData:IBarbarianFuryServerData):string[][] {
        if(rawData.stackedSpinTriggered != undefined && rawData.stackedSpinTriggered) {
            const featureArray:string[] = ArrayHelper.initArrayWithValues<string>(4, (index:number):string => {
                return rawData.activeStackedSymbol;
            });
            const result:string[][] = [];
            rawData.reels.forEach((reelSymbols:string[], reelId:number) => {
                if((<IBarbarianFuryGameData>rawData).initialStackOverlay != null && (<IBarbarianFuryGameData>rawData).initialStackOverlay[reelId]) {
                    result[reelId] = [BarbarianFuryServerDataParser.getRandomLowSymbol()].concat(featureArray).concat([BarbarianFuryServerDataParser.getRandomLowSymbol()]);
                } else {
                    let newReel:string[] = [];
                    reelSymbols.forEach((symbol:string, symbolId:number) => {
                        newReel[symbolId] = symbol === "X" ? rawData.activeStackedSymbol : symbol;
                    });
                    result[reelId] = newReel;
                }
            });
            return ServerDataParser.parseStackedSymbolsInReels(result);
        }
        return ServerDataParser.parseStackedSymbolsInReels(rawData.reels);
    }*/

    public parseStackedModeSymbolInWin(rawData: IBarbarianFuryGameData): boolean[] {
        return rawData.stackedModeSymbolInWin.concat();
    }

    public parseOverlayWildInRespin(rawData: IBarbarianFuryServerData): boolean[] {
        return rawData.overlayWildInRespin.concat();
    }
    public parsewildMultipliersInRespin(rawData: IBarbarianFuryServerData): number[] {
        return rawData.wildMultipliersInRespin.concat();
    }

    public parseExtraSymbolsOnTop(rawData: IBarbarianFuryGameData): string[][] {
        const result: string[][] = [];
        rawData.extraSymbolsOnTop.forEach((reelSymbols: string[], reelId: number) => {
            let newReel: string[] = [];
            reelSymbols.forEach((symbol: string, symbolId: number) => {
                // adding the if condition for #235
                if (rawData.overlayWilds![reelId].indexOf(true) > -1 && symbol.indexOf("M") > -1) {
                    newReel[symbolId] = "L5";
                }
                else {
                    newReel[symbolId] = (symbol === "X") ? rawData.activeStackedSymbol : symbol;
                }
            });
            result[reelId] = newReel;
        });
        return ServerDataParser.parseStackedSymbolsInReels(result);
    }

    public parseReels(rawData: IBarbarianFuryServerData): string[][] {
        let actualData = rawData;

        if (actualData.isRestoreState && (actualData.initialStackOverlay.indexOf(true) > -1)) {
            actualData.reels = this.makeRestoreData(rawData);
        }
        // added this check to fix #271
        if (rawData.isRestoreState) {
            actualData.reels = this.changeScatterPositionReels(rawData);
        }
        return super.parseReels(actualData);
    }

    // function to fix #271
    private changeScatterPositionReels(rawData: IBarbarianFuryServerData): string[][] {
        let reels = rawData.reels;
        for (let i = 0; i < reels.length; i++) {
            if (!rawData.initialStackOverlay[i] && !rawData.overlayWildInRespin[i]) {
                for (let j = 0; j < reels[i].length; j++) {
                    if (reels[i][j].indexOf("M") !== -1) {
                        reels[i][j] = "L4";
                    }
                }
            }
        }
        return reels;
    }

    private makeRestoreData(rawData: IBarbarianFuryServerData) {
        let nudgingReels: any[] = [];
        let activeSymbol: string = "";

        if (rawData.isRestoreState && (rawData.initialStackOverlay.indexOf(true) > -1)) {
            for (let i = 0; i < rawData.initialStackOverlay.length; i++) {
                if (rawData.initialStackOverlay[i]) {
                    nudgingReels.push(Array.from(new Set(rawData.reels[i])));
                }
            }
        }

        for (let i = 0; i < nudgingReels.length; i++) {
            for (let j = 0; j < nudgingReels[i].length; j++) {
                if (nudgingReels[i][j].indexOf("M") > -1) {
                    if (activeSymbol === "" || (activeSymbol === nudgingReels[i][j])) {
                        activeSymbol = nudgingReels[i][j];
                    }
                }
            }
        }

        for (let i = 0; i < rawData.initialStackOverlay.length; i++) {
            if (rawData.initialStackOverlay[i]) {
                for (let j = 1; j < rawData.reels[i].length - 1; j++) {
                    rawData.reels[i][j] = activeSymbol;
                }
            }
        }

        return super.parseReels(rawData);
    }
}